module.exports = __webpack_public_path__ + "img/ks_zine.43e343b6.jpg";